/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_Live_Rate_LimitedInputs */

const vi_vehicle_camera_live_rate_limited = /** @type {(inputs: Vehicle_Camera_Live_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VNetGPS đang giới hạn số lần mở camera. Vui lòng đợi khoảng 1 phút rồi bấm xem lại.`)
};

/**

* @param {Vehicle_Camera_Live_Rate_LimitedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_live_rate_limited = /** @type {((inputs?: Vehicle_Camera_Live_Rate_LimitedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_Live_Rate_LimitedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_live_rate_limited(inputs)
});